var DEFAULT_SALT = 'AL0vBGr4cmOglQgkSVQL';
// https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#examples
export async function hashEmail(email) {
  // encode as UTF-8
  var msgBuffer = new TextEncoder().encode(email + DEFAULT_SALT);
  // hash the message
  var hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  // convert ArrayBuffer to Array
  var hashArray = Array.from(new Uint8Array(hashBuffer));
  // convert bytes to hex string
  var hashHex = hashArray.map(function (b) {
    return b.toString(16).padStart(2, '0');
  }).join('');
  return hashHex.substring(0, 8);
}